module.exports = __webpack_public_path__ + "static/media/Arches.e161f187.jpg";